import api from '../utils/api';
import { cachedGet, invalidateCache } from '../utils/apiCache';

class UsersApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/v1/admin/user', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .put(`/v1/admin/user/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  resetPassword = (id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .patch(`/v1/auth/reset-password-admin/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  delete = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .post(`/v1/admin/user/${id}/anonymize`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Clear deleted: backfills deleted_at for all legacy anonymized accounts
  // (deleted-user-*) so they stop showing in the admin list.
  // Backend route is Super-only (POST /v1/admin/user/clear-deleted).
  clearDeleted = () => {
    return new Promise((resolve, reject) => {
      return api
        .post('/v1/admin/user/clear-deleted')
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  getUserMenus = (id) => {
    return cachedGet(`userMenus:${id}`, async () => {
      const res = await api.get(`/v1/admin/users/${id}/menus`);
      return res.data;
    });
  };
  syncUserMenus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/v1/admin/users/${id}/menus`, data);
        invalidateCache(`userMenus:${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  }
  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/admin/user/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getOldestWithoutRequest = (params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/oldest-without-request', { params });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  clear = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete('/v1/admin/user', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getCount = (scope = 'admin-dashboard') => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/count', {
          headers: {
            'Scope': scope
          }
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  createLanguage = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/admin/translation/bulk', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllLanguages = (recordId, table = 'users', languageCode = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const params = { Table: table };
        if (languageCode) {
          params.LanguageCode = languageCode;
        }
        const res = await api.get(`/v1/admin/translation/record/${recordId}`, { params });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  bulkTranslate = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/admin/translation/bulk-translate', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDailyDashboard = (params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/daily-dashboard', {
          headers: { 'Scope': 'admin-dashboard' },
          params
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDailyDashboardPosthog = (params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/daily-dashboard/posthog/users', {
          headers: { 'Scope': 'admin-dashboard' },
          params
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDailyDashboardPosthogEvents = (params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/daily-dashboard/posthog/events', {
          headers: { 'Scope': 'admin-dashboard' },
          params
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const usersApi = new UsersApi();
export default usersApi;
